import { classEnum } from "./base";

export const CustomerImportValidationTypeEnum = new (class extends classEnum([
    {
        label: "Pelanggan Sudah Ada",
        value: "customerExist",
    },
    {
        label: "KTP Duplikat",
        value: "customerIdentityNumberDuplicate",
    },
    {
        label: "Registrasi Pelanggan Sudah Ada",
        value: "customerRegistrationExist",
    },
    {
        label: "Email Pengguna Sudah Digunakan",
        value: "userEmailExist",
    },
    {
        label: "Email Duplikat",
        value: "userEmailDuplicate",
    },
    {
        label: "Akun Radius Sudah Digunakan",
        value: "radiusAccountExist",
    },
    {
        label: "Akun Radius Duplikat",
        value: "radiusAccountDuplicate",
    },
    {
        label: "Produk Tidak Ditemukan",
        value: "productNotExist",
    },
    {
        label: "Tanggal Terakhir Bayar Kurang Dari Tanggal Aktivasi",
        value: "subscriptionActivationDateFuture",
    },
    {
        label: "Valid",
        value: "isValid",
    },
]) {
    public get valuesCustomer() {
        return this.values.filter((v) => {
            return (
                v === "customerExist" ||
                v === "customerIdentityNumberDuplicate" ||
                v === "customerRegistrationExist" ||
                v === "userEmailExist" ||
                v === "userEmailDuplicate" ||
                v === "isValid"
            );
        });
    }

    public get valuesSubscription() {
        return this.values.filter((v) => {
            return (
                v === "radiusAccountExist" ||
                v === "radiusAccountDuplicate" ||
                v === "productNotExist" ||
                v === "subscriptionActivationDateFuture" ||
                v === "isValid"
            );
        });
    }

    public get ValuesCustomer(): this["valuesCustomer"][number] {
        throw new Error("ValuesCustomer can't be used as a value");
    }

    public get ValuesSubscription(): this["valuesSubscription"][number] {
        throw new Error("ValuesSubscription can't be used as a value");
    }
})();

export namespace CustomerImportValidationTypeEnum {
    export type Labels = (typeof CustomerImportValidationTypeEnum)["labels"][number];
    export type Values = (typeof CustomerImportValidationTypeEnum)["values"][number];
    export type ValuesCustomer = (typeof CustomerImportValidationTypeEnum)["valuesCustomer"][number];
    export type ValuesSubscription = (typeof CustomerImportValidationTypeEnum)["valuesSubscription"][number];
}
